import noticeError from "./notice-error";
import { requestHelper } from "./request-helper";

const getSubmitUrl = () =>
  `${window.location.pathname.replace(/\/+$/, "")}/submit`;

export async function submitRepairRequest(payload) {
  try {
    const { csrfToken } = window.asos.contentPages;

    return await requestHelper.post({
      url: getSubmitUrl(),
      headers: {
        "Content-Type": "application/json",
        "x-csrf-token": csrfToken,
      },
      body: payload,
    });
  } catch (error) {
    noticeError(error);

    const submitError = new Error("Failed to submit repair request.");
    submitError.status = error?.response?.status;
    throw submitError;
  }
}
